import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ISelectedGroupItemState {
    reset: () => void;
    selectedGroupIndex: number | null;
    selectedItemIndex: number | null;
    setSelectedGroupItem: (data: { itemIndex: number; groupIndex: number }) => void;
    setSelectedItemIndex: (index: number) => void;
}

const initialState = {
    selectedItemIndex: null,
    selectedGroupIndex: null,
};

export const useSelectedGroupItemStore = create<ISelectedGroupItemState>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState, false, "reset"),
            setSelectedGroupItem: ({ groupIndex, itemIndex }) =>
                set(
                    {
                        selectedGroupIndex: groupIndex,
                        selectedItemIndex: itemIndex,
                    },
                    false,
                    "setSelectedGroupItem",
                ),
            setSelectedItemIndex: (index) => set({ selectedItemIndex: index }, false, "setSelectedItemIndex"),
        }),
        { name: "SelectedGroupItemStore" },
    ),
);
